import { Transform } from "../../../../geometry/transformation";
import { createTextRubber } from "../../tools/TextRubber";
import { registerRendererGroup, registerToolRendererGroup, ShapeFunctions } from "../../util/shapeCategorySingleton";
import { createText, createTextBase, globalText, textIntersectCheck, transformToInternalText } from "./Text";
import createDefaultPropertyPalette from "./TextDefaultProperyPalette";
import createPropertyPalette from "./TextProperyPalette";

const textFunctions: ShapeFunctions = {
    shapeRendererGroup: {
        shapeRender: createText,
        rubberlineRender: createTextRubber,
        baseShapeRenderer: createTextBase,
    },
    shapeTransformerGroup:
    {
        snapPointCalculator: (s: GeometricShape) => { return { ...s, snapPoint: [(new Transform(s.transformation).point2d(s as TextShape))] }; },
        rectangleIntersectCheck: textIntersectCheck,
        globalShapeTransformer: globalText,
        transformToInternalShape: transformToInternalText,
        calculateWidthHeight: (s: GeometricShape) => { return { width: 0, height: 0 } },
    },
    UIElementRender:
    {
        propertyPaletteRenderer: createPropertyPalette,
        defaultPropertyPaletteRenderer: createDefaultPropertyPalette,
    },
}
registerRendererGroup(
    "text",
    textFunctions,
);
registerToolRendererGroup("text", { toolRender: createTextRubber })